import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=77ace8c5&"
import script from "./Customer.vue?vue&type=script&lang=js&"
export * from "./Customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ace8c5')) {
      api.createRecord('77ace8c5', component.options)
    } else {
      api.reload('77ace8c5', component.options)
    }
    module.hot.accept("./Customer.vue?vue&type=template&id=77ace8c5&", function () {
      api.rerender('77ace8c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Customer/Customer.vue"
export default component.exports